import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import HomePage from "./layouts/HomePage/HomePage";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { LoaderContextProvider } from "./context/LoaderContext.jsx";

// Ana sayfa dışındaki rotalar ayrı chunk'lara bölünür
const Work = lazy(() => import("./pages/Work/Work"));
const About = lazy(() => import("./pages/About/About"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const ProjectsPage = lazy(() => import("./pages/Projects/ProjectsPage"));
const SocialMedia = lazy(() => import("./pages/SocialMedia/SocialMedia"));
const WebServicesPage = lazy(() => import("./pages/WebServices/WebServicesPage"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

function App() {
    return (
        <HelmetProvider>
        <div className="app">
            <LoaderContextProvider>
                <BrowserRouter
                    future={{
                        v7_startTransition: true,
                        v7_relativeSplatPath: true,
                    }}
                >
                    <Header />
                    <Suspense fallback={<div className="min-h-[calc(100vh-104px)] bg-black" aria-hidden="true" />}>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/work" element={<Work />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/social-media" element={<SocialMedia />} />
                            <Route path="/web-services" element={<WebServicesPage />} />
                            <Route
                                path="/projects/:category"
                                element={<ProjectsPage />}
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Suspense>
                    <Footer />
                </BrowserRouter>
            </LoaderContextProvider>
        </div>
        </HelmetProvider>
    );
}

export default App;
